module.exports = __webpack_public_path__ + "img/gear.23e0e93a.png";